import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import pt from 'vuetify/es5/locale/pt'
import config from '../config'

Vue.use(Vuetify);

export default new Vuetify({
    theme: config[process.env.NODE_ENV].theme,
    iconfont: 'md',
    lang: {
        locales: { pt },
        current: 'pt'
    }
});
